module.exports = __webpack_public_path__ + "img/about1.a6cccb5b.png";